import { render } from "./officialAccountsCreat.vue?vue&type=template&id=05863690&scoped=true"
import script from "./officialAccountsCreat.vue?vue&type=script&lang=js"
export * from "./officialAccountsCreat.vue?vue&type=script&lang=js"

import "./officialAccountsCreat.vue?vue&type=style&index=0&id=05863690&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05863690"]])

export default __exports__